import { DentalOfficeShiftCard } from '@tempmee/react-blocks';
import { InviteProfessionalPopup } from '~/commonComponents/InviteProfessional/Popup';
import { CancelShiftConfirmPopup } from '~/components/shared/CancelShiftConfirmPopup';
import {
  type IShiftOverviewCardProps,
  useShiftOverviewCard,
} from './useShiftOverviewCard';

export const ShiftOverviewCard = (props: IShiftOverviewCardProps) => {
  const { item, onCardClick, invite } = props;
  const {
    cardData,
    isInterview,
    handleInvite,
    menuItems,
    isInvitePopupOpen,
    closeInvitePopup,
    isCancelPopupOpen,
    closeCancelPopup,
    confirmCancel,
    isCancelPending,
  } = useShiftOverviewCard(props);

  return (
    <>
      <DentalOfficeShiftCard
        {...cardData}
        onMessage={handleInvite}
        menuItems={menuItems}
        onCardClick={() => onCardClick(item)}
        data-cy="shift-overview-card"
      />

      {isInvitePopupOpen && (
        <InviteProfessionalPopup
          isOpen={isInvitePopupOpen}
          isRefetchJob
          jobId={item.id}
          profession={item.dashboardJobApi?.profession}
          officeId={item.office?.id}
          onClose={closeInvitePopup}
          trackingSource={invite?.trackingSource}
        />
      )}

      {isCancelPopupOpen && (
        <CancelShiftConfirmPopup
          isInterview={isInterview}
          date={item.date}
          isPending={isCancelPending}
          onClose={closeCancelPopup}
          onConfirm={confirmCancel}
        />
      )}
    </>
  );
};
